import { HourTypeModelAPI } from '../../../../models';
import { getHourTypesAdapter } from '../../Adapters/days/HourTypes.adapter';
import { requests } from '../apiAgent';

export const HourTypesAPI = {
    getHousTypes: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/hour-types')
            .then((response: HourTypeModelAPI[]) => getHourTypesAdapter(response));
    },
};
